const mobile = 'web_mobile';
const desktop = 'web_desktop';
function detectDevice(userAgent) {
    const isMobile = /Mobi/.test(userAgent);
    return isMobile ? mobile : desktop;
}

export { desktop, detectDevice, mobile };
//# sourceMappingURL=detect-device.js.map
